import type { CSSProperties, ReactNode } from "react";

interface MultiLineEllipsisProps {
  clamp?: number;
  children?: ReactNode;
  className?: string;
}

export const MultiLineEllipsis = ({
  clamp = 3,
  children,
  className = ""
}: MultiLineEllipsisProps) => {
  return (
    <div
      className={["line-clamp", className].filter(Boolean).join(" ")}
      style={{ "--line-clamp": String(clamp) } as CSSProperties}
    >
      {children}
    </div>
  );
};

export default MultiLineEllipsis;
